// ActionButtons.tsx
import React from 'react';
import { Button } from '../../../../components/ui/button';
import { FilePlus } from 'lucide-react';
import NewFolderModal from '../Modals/NewFolderModal';
import { useNavigate } from 'react-router-dom';

interface ActionButtonsProps {
  onNewFolder: (folderName: string) => void;
  // onNewBlog: (data: {
  //   title: string;
  //   context: string;
  //   file_name: string;
  //   images_urls: string;
  // }) => void;
  disabled?: boolean;
}

export const ActionButtons: React.FC<ActionButtonsProps> = ({
  onNewFolder,
  // onNewBlog,
  disabled,
}) => {
  const navigate = useNavigate();

  const handleNewBlog = () => {
    navigate('/ai-blog-writer/get-started');
    // This is a simplified example - you might want to open a modal or navigate to a new page
    // onNewBlog({
    //   title: 'New Blog',
    //   context: '',
    //   file_name: 'new-blog',
    //   images_urls: '',
    // });
  };

  return (
    <div className="flex gap-2">
      <NewFolderModal onNewFolder={onNewFolder} disabled={disabled} />
      <Button
        size="sm"
        variant="customSecondary"
        className="gap-2 text-[14px] bg-secondary"
        onClick={handleNewBlog}
        disabled={disabled}
      >
        <FilePlus size={16} />
        New Blog
      </Button>
    </div>
  );
};
